/**
 * Evita tarjetas duplicadas en rejillas de colección/búsqueda cuando el scroll infinito
 * inserta dos veces el mismo HTML o cuando Liquid y metaobjetos generan el mismo producto.
 * Conserva la primera aparición de cada data-product-handle dentro de .product-list__inner.
 */
(function () {
  function dedupeProductListInner(inner) {
    if (!inner || !inner.querySelectorAll) return;
    var seen = Object.create(null);
    var items = inner.querySelectorAll('.product-item[data-product-handle]');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var h = el.getAttribute('data-product-handle');
      if (!h) continue;
      if (seen[h]) {
        el.remove();
      } else {
        seen[h] = true;
      }
    }
  }

  function attach(inner) {
    dedupeProductListInner(inner);
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          dedupeProductListInner(inner);
          return;
        }
      }
    });
    mo.observe(inner, { childList: true, subtree: false });
  }

  function boot() {
    var inner = document.querySelector('#facet-main .product-list__inner');
    if (inner) attach(inner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
